import type { Locale } from 'date-fns';
import { enUS, es, fr, ptBR, ru } from 'date-fns/locale';

export const dateFnsLocale = (language: string): Locale => {
  if (language.startsWith('ru')) return ru;
  if (language.startsWith('es')) return es;
  if (language.startsWith('fr')) return fr;
  if (language.startsWith('pt')) return ptBR;
  return enUS;
};
